import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useProfile } from "@/context/ProfileContext";

/**
 * Standalone alerts for admin impersonation or acting as a business member.
 * Renders nothing when neither applies — safe to mount without AppHeader.
 */
export function AppSessionBanners() {
  const {
    businessProfile,
    isSignedInAsBusinessMember,
    signOutAsBusinessMember,
    isImpersonating,
    impersonationInfo,
    endImpersonation,
    memberProfile,
  } = useProfile();

  if (isImpersonating) {
    return (
      <div className="flex flex-col gap-2 border-b border-border bg-amber-500/20 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className="font-semibold">Admin-impersonering aktiv</span>
          <span>
            Du är inloggad som{" "}
            <span className="font-medium">
              {memberProfile?.name || memberProfile?.email || "medlem"}
            </span>{" "}
            i{" "}
            <Link to="/settings" className="font-medium text-primary">
              {businessProfile?.business ?? "företaget"}
            </Link>
            {impersonationInfo?.impersonatedByEmail
              ? ` (från ${impersonationInfo.impersonatedByEmail})`
              : null}
            .
          </span>
        </div>
        <Button onClick={endImpersonation} variant="default">
          Avsluta impersonering
        </Button>
      </div>
    );
  }

  if (isSignedInAsBusinessMember) {
    return (
      <div className="flex justify-between border-b border-border bg-primary/15 p-4">
        <div className="flex items-center gap-2">
          Du är just nu inloggad som företaget{" "}
          <Link to="/settings" className="text-primary">
            {businessProfile?.business}
          </Link>
        </div>
        <Button onClick={signOutAsBusinessMember}>
          Logga ut som företaget
        </Button>
      </div>
    );
  }

  return null;
}
